import { FieldOptionBase } from 'module/api/field/types';
import { fullName } from 'module/helpers/full-name';
import { getRandomColor } from 'module/helpers/get-random-color';
//import { useTranslate } from 'module/hooks/use-translation';
import { SingleUserField } from 'module/types/filter-field/field/filterable-field';
import { NoValue } from 'module/ui/components/atoms/no-value/empty-cell';
import { UserTag } from 'module/ui/components/atoms/select';
import { StyledSelect } from 'module/ui/components/molecules/field-editors/components/components';
import { forwardRef } from 'react';
import { EditableProps } from './editable-props';
//import { EditableUserRelatedFieldProps } from './editable-props';

interface Props extends EditableProps<number> {
  field: SingleUserField;
}

export const SingleUserFieldValue = forwardRef<HTMLDivElement, Props>(
  ({ field, editable, onChange }, ref) => {
    const { users, options } = field.metaData;

    //const translate = useTranslate();
    const selected_user = users.by_user_id[field.value!];

    return !editable ? (
      selected_user == null ? (
        <NoValue />
      ) : (
        <UserTag
          color={getRandomColor(selected_user.userId)}
          imageUrl={selected_user.photoUrl}
          label={fullName(selected_user)}
          userStatus={selected_user?.userStatus}
        />
      )
    ) : (
      <StyledSelect
        ref={ref}
        type="user"
        isClearable
        menuIsOpen={false}
        options={options}
        value={
          [selected_user].filter(Boolean).map((x) => ({
            label: fullName(x!),
            description: x!.role?.roleName,
            imageUrl: x!.photoUrl,
            value: x!.userId,
            color: getRandomColor(x!.userId),
          }))[0]
        }
        onChange={(latest: FieldOptionBase) => onChange?.(latest?.value)}
      />
    );
  },
);

SingleUserFieldValue.displayName = 'SingleUserFieldValue';
